module.exports = __webpack_public_path__ + "img/electricity.cff57f77.png";